import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 50,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        // Don't retry client or auth errors
        if (status && status >= 400 && status < 500) {
          return false;
        }
        // Retry transient failures
        return failureCount < 3;
      },
      retryDelay: attempt => Math.min(1000 * 2 ** attempt, 30000),
    },
    mutations: {
      retry: false,
    },
  },
});
